var _excluded = ["as", "active", "id"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { useUniqueID } from "@xo-union/react-unique-id";
import useSet from "../utils/useSet.js";
var DialogHeadingContext = /*#__PURE__*/React.createContext({
  add: noop,
  "delete": noop
});
var DialogHeadingDescribeIDsProvider = function DialogHeadingDescribeIDsProvider(_ref) {
  var children = _ref.children;
  var _useSet = useSet(),
    _useSet2 = _slicedToArray(_useSet, 2),
    headingIDsSet = _useSet2[0],
    headingIDsSetActions = _useSet2[1];
  var describeIDs = headingIDsSet.size === 0 ? undefined : _toConsumableArray(headingIDsSet).join(' ');
  return /*#__PURE__*/React.createElement(DialogHeadingContext.Provider, {
    value: headingIDsSetActions
  }, children(describeIDs));
};
process.env.NODE_ENV !== "production" ? DialogHeadingDescribeIDsProvider.propTypes = {
  children: PropTypes.func
} : void 0;

/**
 * Render a header that will be automatically associated via `aria-labelledby` with parent ModalContainer
 *
 * Passes ref to underlying element
 */
var DialogHeading = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var Type = _ref2.as,
    active = _ref2.active,
    idProp = _ref2.id,
    props = _objectWithoutProperties(_ref2, _excluded);
  var id = useUniqueID(idProp);
  var headerIDsSetActions = React.useContext(DialogHeadingContext);
  React.useEffect(function () {
    if (active) {
      headerIDsSetActions.add(id);
    } else {
      headerIDsSetActions["delete"](id);
    }
    return function () {
      return headerIDsSetActions["delete"](id);
    };
  }, [active, id, headerIDsSetActions]);
  return /*#__PURE__*/React.createElement(Type, _extends({
    ref: ref,
    id: id
  }, props));
});
DialogHeading.defaultProps = {
  as: 'h1',
  active: true
};
process.env.NODE_ENV !== "production" ? DialogHeading.propTypes = {
  /**
   * Override the id
   */
  id: PropTypes.string,
  /**
   * Whether or not header is active. This is useful in cases where a modal screen with a header is animated. Rendering the header won't
   * automatically associate the underlying element with its parent Modal unless `active=true`
   */
  active: PropTypes.bool,
  /**
   * Underlying element type to render
   */
  as: PropTypes.elementType
} : void 0;
DialogHeading.displayName = 'DialogHeading';
export { DialogHeading, DialogHeadingDescribeIDsProvider };